import { render, staticRenderFns } from "./TeacherDetailModal.vue?vue&type=template&id=4c9f3c26&scoped=true"
import script from "./TeacherDetailModal.vue?vue&type=script&lang=js"
export * from "./TeacherDetailModal.vue?vue&type=script&lang=js"
import style0 from "./TeacherDetailModal.vue?vue&type=style&index=0&id=4c9f3c26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9f3c26",
  null
  
)

export default component.exports